"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRenderers = void 0;
const mithril_1 = __importDefault(require("mithril"));
const detail_link_1 = require("../widgets/detail_link");
const helpers_1 = require("./helpers");
const MONEY_INFOS = {
    "EUR": (money) => {
        return (0, helpers_1.moneyToString)(money);
    }
};
exports.TableRenderers = {
    money(_, value) {
        return (0, mithril_1.default)("span", {}, MONEY_INFOS[value.currency](value));
    },
    date(_, value) {
        return (0, mithril_1.default)("span", { class: "is-size-7" }, (0, helpers_1.formatTime)(value, true));
    },
    dateOnly(_, value) {
        return (0, mithril_1.default)("span", { class: "is-size-7" }, (0, helpers_1.formatTime)(value, false));
    },
    time(_, value) {
        return (0, mithril_1.default)("span", (0, helpers_1.minutesToUnit)(value));
    },
    dateAt(_, value) {
        return (0, mithril_1.default)("span", { class: "is-size-7" }, (0, helpers_1.formatTime)(value, true));
    },
    bool(_, value) {
        return value ? (0, helpers_1.tag)("Oui", "success") : (0, helpers_1.tag)("Non", "danger");
    },
    resourceLink(resourceName, action = "show", id, label) {
        let labelNotNull = label || id;
        return function (mdl, value) {
            return (0, helpers_1.tag)((0, mithril_1.default)("a", { href: "#" + (0, detail_link_1.getDetailLinks)(resourceName, id(mdl, value), action) }, labelNotNull(mdl, value)));
        };
    },
    identity(_, value) {
        return (0, mithril_1.default)("span", {}, value);
    },
    tag(cb, color = "light") {
        return function (mdl, value) {
            return (0, helpers_1.tag)(cb(mdl, value), color);
        };
    },
    action(onclick, cb) {
        return function (mdl, value) {
            return (0, mithril_1.default)("span", { style: "cursor: pointer;", onclick: (evt) => { evt.preventDefault(); onclick(mdl, value); } }, cb(mdl, value));
        };
    },
    maybe(cb, def) {
        def = def || (0, mithril_1.default)("span", { class: "empty" }, "Vide");
        return function (mdl, value) {
            return value != undefined ? cb(mdl, value) : def;
        };
    }
};
